import { SceneContainer } from "GameObjects/StoryGame/SceneContainer";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";

export default class Lantern extends SceneContainer {
    readonly shadow = this.addChild(new SceneSprite());
    readonly offSprite = this.addChild(new SceneSprite());
    readonly onSprite = this.addChild(new SceneSprite());
}